import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { Paper, Button, Table, TableBody, TableCell, TableRow, TableHead, Grid, Checkbox, Box } from '@mui/material';
import ShopVisitList from '../components/ShopVisitList';
import useBulkSelectHook from '../hooks/useBulkSelectHook';
import { useShopVisitActions } from '../hooks/useApiHook';
import { getMaintenanceEventApi, getMajorAssemblyApi, getShopVisitListApi } from '../apiServices';
import { LeasesBasicDetails, LeasesMenuList, LeasesNav } from '../../elements';
import DeletePopUp from '../../../shared_elements/components/DeletePopUp';
import { ButtonLoader, ShowAttachments } from '../../../shared_elements/components';
import { FilterComponent, NoRecordFound, PageLoader, Pagination, STableLoader } from '../../../shared_elements';
import { checkApiStatus, } from '../../../utils';
import { globalGetService } from '../../../utils/globalApiServices';
import useTableSortingHook from '../hooks/useTableSortingHook';
import "../_shopvisit.scss"
import ShopVisitCRU from '../components/ShopVisitCru';
import RevisionHistory from '../../../shared_elements/components/RevisionHistory';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { enqueueSnackbar } from 'notistack';
import FileUploadLayout from '../../../shared_elements/components/FileUploadLayout';
import fileUpload, { getApiResponse } from '../../../utils/fileUpload';
import { getStorage } from '../../../shared_elements/actionCreators';
import ModuleWiseRevisionHistory from '../../../shared_elements/components/ModuleWiseRevisionHistory';
import { isMobile } from 'react-device-detect';
import { trackActivity } from '../../../utils/mixpanel';
import ModuleNotExcessModal from '../../../shared_elements/components/ModuleNotExcessModal';
import { RoleBaseAccess } from '../../../hoc';
import { PermissionWrapper } from '../../../wrappers';
import BackToLeaseList from '../../elements/BackToLeaseList';
import { assetType } from '../../../constants';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const TABLE_HEIGHT = 'calc(100vh - 223px)';

const shopvisitStatusOptions = [
    { label: 'Workscope Submitted', value: 1 },
    { label: 'Workscope In-Review', value: 2 },
    { label: 'Workscope Approved', value: 5 },
    { label: 'Workscope Rejected', value: 6 },
    { label: 'Shopvisit In-Review', value: 7 },
    { label: 'Approved', value: 3 },
    { label: 'Rejected', value: 4 },
];

const ShopVisitHd = ({ toggleBulkOps, tableSorting, item, bulk }) => {
    const deletableItems = item?.filter(listItem => listItem?.status?.value !== 3) || [];
    return (
        <TableHead>
            <TableRow >
                <TableCell className="table-actions-header" sx={{ width: 140, whiteSpace: "nowrap" }}>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "shop_visit", operationType: ['D'] }}>
                        <Checkbox color='primary' size='small' onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', deletableItems)} checked={deletableItems?.length === bulk?.ids?.length && deletableItems?.length > 0} /></PermissionWrapper> Action(s)
                </TableCell>
                <TableCell sx={{ width: '100px' }}> {tableSorting('asset_type', 'Assembly')}</TableCell>
                <TableCell sx={{ minWidth: '100px' }}> {tableSorting('maintenance_check_id', 'SV Event')}</TableCell>
                <TableCell sx={{ minWidth: '110px' }}> {tableSorting('shop_visit_start_date', 'SV Start Date')}</TableCell>
                <TableCell sx={{ minWidth: '110px' }}> {tableSorting('shop_visit_end_date', 'SV End Date')}</TableCell>
                <TableCell sx={{ minWidth: '110px' }}> {tableSorting('tsn', 'TSN @ SV')}</TableCell>
                <TableCell sx={{ minWidth: '110px' }}> {tableSorting('csn', 'CSN @ SV')}</TableCell>
                <TableCell sx={{ minWidth: '110px' }}> {tableSorting('cost', 'SV Cost')}</TableCell>
                <TableCell sx={{ minWidth: '250px' }}>  Reason For Shopvisit</TableCell>
                <TableCell sx={{ minWidth: '110px' }}> {tableSorting('status', 'SV Status')}</TableCell>
            </TableRow>
        </TableHead>
    );
};

const ShopVisit = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const params = useParams();
    const { leaseBasicDetails, fileUploadDetails } = useSelector((state) => state.leases);
    const assetData = leaseBasicDetails?.asset
    const [isLoading, setLoading] = useState({ skeletonLoader: false, pageLoader: false, buttonLoader: false });
    const [shopVisitInfo, setShopVisitInfo] = useState({ list: [], pagination: {}, });
    const toggleLoader = (type, status) => { setLoading({ [type]: status }) }
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
    const [deleteShopVisit, setDeleteShopVisit] = useState({ modal: false, data: null });
    const [addEditShopVisit, setAddEditShopVisit] = useState({ mode: '', modal: false, data: null });
    const [uploadfileList, setUploadfileList] = useState({ mode: '', modal: false, data: null });
    const { bulk, openBulkModal, toggleBulkOps, resetBulkToggle } = useBulkSelectHook()
    const [isExport, seIsExport] = useState(false)
    const [uploadFileProgressData, setUploadFileProgressData] = useState({})
    const [uploadFileStatus, setUploadFileStatus] = useState({ mode: '', modal: false, data: null });
    const [slug, setSlug] = useState({})
    const [filter, setFilter] = useState({});
    const { deleteShopVisitFnc } = useShopVisitActions();
    const [queryConfig, setQueryConfig] = useState({
        page: shopVisitInfo?.pagination?.page || 1,
        per_page: shopVisitInfo?.pagination?.per_page || 50,
    });
    const [pltConstants, setPltConstants] = useState()
    const getShopVisitList = (query = {}, loaderType) => {
        loaderType === 'skeletonLoader' ? toggleLoader("skeletonLoader", true) : toggleLoader("pageLoader", true);
        const updatedQueryParams = assetData?.asset_type === 1
            ? { ...query, parent_asset_id: assetData?.id, asset_type : assetData?.asset_type  , lease_slug : params?.leaseSlug }
            : { ...query, asset_id: assetData?.id, asset_type : assetData?.asset_type,lease_slug : params?.leaseSlug };
        globalGetService(getShopVisitListApi(assetData?.slug, updatedQueryParams), {}).then(response => {
            if (checkApiStatus(response)) { setShopVisitInfo(response?.data?.data); }
            loaderType === 'skeletonLoader' ? toggleLoader("skeletonLoader", false) : toggleLoader("pageLoader", false);
        });
        dispatch(getStorage({ lease_slug: params?.leaseSlug, module_name: "shop_visit" }))
    };
    const getMajorAssembly = async () => {
        const response = await globalGetService(getMajorAssemblyApi(params))
        if (response) {
            if (checkApiStatus(response)) {
                const updatedResponse = response?.data?.data?.map(ele => { return { ...ele, asset_id: ele.id } })
                setPltConstants((prev) => ({ ...prev, asset_types: updatedResponse }))
            }
        }
    }
    const getMaintenanceEvent = async (assemblyList = []) => {
        if (!Array.isArray(assemblyList) || assemblyList.length === 0) {
            setPltConstants(prev => ({ ...prev, maintenance_events: [] }));
            return;
        }
        try {
            const responses = await Promise.all( assemblyList.map(item => globalGetService( getMaintenanceEventApi( assetType?.[item.type], item.id ) ) ) );
            let allEvents = [];
            responses.forEach(response => {
                if (response && checkApiStatus(response)) {
                    const data = response?.data?.data;
                    if (!Array.isArray(data)) return; 
                    data.forEach(entry => {
                        const events = entry?.maintenance_events;
                        if (!Array.isArray(events)) return; 
                        const formatted = events.map(ev => ({ value: ev?.id, label:  ev?.name || '' }));
                        allEvents.push(...formatted);
                    });
                }
            });
            const uniqueEvents = Object.values( allEvents.reduce((acc, item) => { if (item?.value !== undefined) { acc[item.value] = item; } return acc; }, {}) );
            setPltConstants(prev => ({ ...prev, maintenance_events: uniqueEvents }));
    
        } catch (err) {
            console.error("Error fetching maintenance events", err);
            setPltConstants(prev => ({ ...prev, maintenance_events: [] }));
        }
    };
    const handleDependencyChange = (key, value) => {
        if (key !== 'assembly') return;
        if (!value) {
            getMaintenanceEvent([]); 
            return;
        }
        const values = typeof value === 'string' ? value.split(',') : [];
        const finalAssembly = values.map(v => { const [type, id] = v?.split('_') || []; if (!type || !id) return null; return { type: Number(type), id: Number(id) }; }).filter(Boolean); 
        getMaintenanceEvent(finalAssembly);
    };
    const assetTypesWithKey = (pltConstants?.asset_types || []).map(item => ({
        ...item,
        composite_key: `${item.asset_type || item.type}_${item.id}`
    }));

    const shopvisitFilterMenu = {
        assembly: { title: 'Assembly', inputType: 'dropdown', options: assetTypesWithKey, valueKey: 'composite_key', labelKey: 'name', dependentFields: ['maintenance_check_id'], multiple: true },
        maintenance_check_id: { title: 'SV Event', inputType: 'dropdown', options: pltConstants?.maintenance_events || [], valueKey: 'value', labelKey: 'label', },
        status: { title: 'Status', inputType: 'dropdown', options: shopvisitStatusOptions, valueKey: 'value', labelKey: 'label', multiple: true },
        shop_visit_start_date: { title: 'Shopvisit Start Date', inputType: 'date' },
        shop_visit_end_date: { title: 'Shopvisit End Date', inputType: 'date' },
        onDependencyChange: handleDependencyChange
    };
    const createSortHandler = (key) => {
        const isAsc = queryConfig.sort_by === key && queryConfig.sort === 'asc';
        const updatedSort = isAsc ? 'desc' : 'asc';
        setQueryConfig({
            page: shopVisitInfo?.pagination?.page || 1,
            per_page: shopVisitInfo?.pagination?.per_page || 50,
            sort_by: key,
            sort: updatedSort
        });
        getShopVisitList({
            page: shopVisitInfo?.pagination?.page || 1,
            per_page: shopVisitInfo?.pagination?.per_page || 50,
            sort: updatedSort,
            sort_by: key,
        });
    };
    const onDeleteShopvisit = async () => {
        const idsToDelete = { ids: (bulk?.type === 'bulk' || bulk?.type === 'single') && bulk.modal ? bulk?.ids?.map(item => item.id) : [deleteShopVisit?.data?.id] }
        const response = await deleteShopVisitFnc(assetData, idsToDelete, toggleLoader);
        if (response) {
            setDeleteShopVisit({ modal: false, data: null });
            resetBulkToggle()
            getShopVisitList(queryConfig);
        }
    };
    const { tableSorting } = useTableSortingHook(queryConfig, createSortHandler)
    useEffect(() => {
        trackActivity('Page Viewed', { page_title: 'Shop Visit' })
        getMajorAssembly()
    }, []);

    useEffect(() => {
        if (!leaseBasicDetails) return;
        if (leaseBasicDetails?.status === "Draft") return;
        if (assetData?.id) { getShopVisitList({ per_page: 50 }, 'skeletonLoader'); }
    }, [assetData]);

    const onDeleteAttachments = (deltedslug) => {
        setUploadfileList({
            ...uploadfileList, data: {
                ...uploadfileList.data,
                attachments: uploadfileList.data.attachments.filter(item => item.slug !== deltedslug)
            }
        });
        if (addEditShopVisit?.modal) {
            setAddEditShopVisit({
                ...addEditShopVisit,
                data: {
                    ...addEditShopVisit.data,
                    attachments: addEditShopVisit.data.attachments.filter(item => item?.slug !== deltedslug)
                }
            })
        }
        getShopVisitList(queryConfig);
    }

    const handleExport = () => {
        let query = {
            export: true,
            ...(assetData?.asset_type === 1
                ? { parent_asset_id: assetData?.id, lease_slug : params?.leaseSlug, asset_type: assetData?.asset_type  }
                : { asset_id: assetData?.id, lease_slug : params?.leaseSlug, asset_type: assetData?.asset_type }),
            ...(queryConfig?.sort && queryConfig?.sort_by && {
                sort: queryConfig.sort,
                sort_by: queryConfig.sort_by,
            }),
        };
        seIsExport(true);
        globalGetService(getShopVisitListApi(assetData?.slug, query)).then((response) => {
            if (checkApiStatus(response)) {
                enqueueSnackbar(
                    response?.data.message,
                    { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } }
                );
                seIsExport(false);
            }
        })
    }

    const handleUpload = async (slug, mode) => {
        setSlug({ slug: slug })
        await fileUpload({
            attachments: fileUploadDetails.attachments,
            module_name: "shop_visit",
            slug: slug,
            query: { record_action_type: mode },
            onStart: () => setLoading(true),
            onComplete: () => setLoading(false),
            onProgress: ({ progressRefs, attachments, response }) => {
                setUploadFileProgressData({ progressRefs, attachments, response });
            },
            onSuccess: (success_msg) => {
                enqueueSnackbar(success_msg, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
                getShopVisitList( { per_page: shopVisitInfo?.pagination?.per_page || 50 });
            },
            onError: (err) => {
                enqueueSnackbar(`${err?.message}` || "Error while uploading files", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
            }
        });
        setSlug({})
    }
    const onApplyFilter = (query) => {
        const apiQuery = query?.assembly ? {
            ...query,
            assembly: JSON.stringify(
                query.assembly.split(',').map(v => {
                    const [type, id] = v.split('_');
                    return {
                        type: Number(type),
                        id: Number(id)
                    };
                })
            )
        } : query;
        setFilter(apiQuery);
        getShopVisitList({ ...apiQuery, page: 1, per_page: shopVisitInfo?.pagination?.per_page || 50 });
    };
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Shop Visit`, page_type: page_type, })
    }


    return (
        <> <LeasesBasicDetails />
            <Paper className='lease-details-section lease-nav-module-margin lease-module-paper' elevation={0}>
                <LeasesNav />
                {leaseBasicDetails?.status === "Draft" ? (<ModuleNotExcessModal moduleName="Shop Visit" />) : leaseBasicDetails && Object.keys(leaseBasicDetails).length > 0 && !leaseBasicDetails?.status ? (<ModuleNotExcessModal leaseNotFound />) :
                    <div className='lease-details-content'>
                        <Paper square className="responsive-paper">
                            <Grid container spacing={1} className="responsive-grid" alignItems='end'>
                                <Grid item size={{ md: 12, xs: 12 }} sx={{mb:-1, marginLeft: "3px"}} className="menu-container lease-list-link-mt">
                                    <BackToLeaseList />
                                </Grid>
                                <Grid md={4} xs={12} size='grow' sx={{ minWidth: 0, overflow: 'hidden' }}>
                                    {!isLoading?.skeletonLoader ? <Box display="flex" alignItems="center"  gap={1} sx={{marginTop:'5px', marginLeft: "-2px" }} flexShrink={0}><FilterComponent filter={filter} filterMenu={shopvisitFilterMenu} getResponseBack={onApplyFilter} /></Box> : null}
                                </Grid>
                                <Grid md={8} xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <ul className='list-inline lease-details-right-items lease-details-btn' style={{ padding: '0px', float: 'right' }}>
                                        <li className='lease-mobile-button revision-history'><ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: { slug: params?.leaseSlug, type: "global" } })} /> </li>
                                        {
                                            bulk?.type && bulk?.ids?.length ?
                                                <>
                                                    <li className='lease-mobile-button'>
                                                        <Button onClick={() => { resetBulkToggle(); handleItemClicked('Bulk Delete Cancel Button') }} size="small" variant="outlined" color="primary" >Cancel</Button>
                                                    </li>
                                                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "shop_visit", operationType: ['D'] }}>
                                                        <li className='lease-mobile-button'>
                                                            <Button onClick={() => { openBulkModal(); handleItemClicked('Bulk Delete Button') }} variant="contained" size="small" color='error'>{`Delete (${bulk?.ids?.length})`}</Button>
                                                        </li>
                                                    </PermissionWrapper>
                                                </> : null
                                        }
                                        {shopVisitInfo?.list?.length > 0 ? <li className='lease-mobile-button'> <Button startIcon={isExport ? <ButtonLoader size={15} /> : <ArrowDownwardIcon />} onClick={() => { handleExport(); handleItemClicked('Export Button') }} variant="outlined" size='small' className='btn-primary action-btn-start-icon'> Export </Button>  </li> : null}
                                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "shop_visit", operationType: ['C'] }}>
                                            <li className='lease-mobile-button'> <Button startIcon={<AddOutlinedIcon />} className='btn-primary action-btn-start-icon' variant="contained" color="primary" size='small' onClick={() => { setAddEditShopVisit({ modal: true, data: null, mode: 'add' }); handleItemClicked('Add Item Button') }} > Add Shop Visit </Button> </li>
                                        </PermissionWrapper>
                                    </ul>
                                </Grid>
                            </Grid>
                        </Paper>
                        <Paper className='lease-detail-table table-container lease-module-paper' elevation={0} sx={{ display: 'flex', flexDirection: 'column', maxHeight: TABLE_HEIGHT, height: shopVisitInfo?.list?.length > 0 ? `${TABLE_HEIGHT} !important` : 'auto !important' }}>
                            <div style={{ flex: '1 1 auto', overflow: 'auto', minHeight: 0 }}>
                                {isLoading?.skeletonLoader || !assetData ? <STableLoader count={6} rowCount={11} /> : (
                                    <Table className='mui-table-format' stickyHeader>
                                        <ShopVisitHd item={shopVisitInfo?.list} toggleBulkOps={toggleBulkOps} bulk={bulk} tableSorting={tableSorting} />
                                        <TableBody>
                                            {shopVisitInfo?.list?.length > 0 && shopVisitInfo?.list.map((item, index) => {
                                                const uploadedFileData = getApiResponse("shop_visit", item?.slug);
                                                return (
                                                    <ShopVisitList
                                                        slug={slug?.slug}
                                                        uploadedFileData={uploadedFileData}
                                                        uploadFileProgressData={uploadFileProgressData}
                                                        viewFileStatus={(uploadedFileData) => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}
                                                        deleteShopVisit={deleteShopVisit}
                                                        key={index}
                                                        item={item}
                                                        bulk={bulk}
                                                        params={params}
                                                        viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                                                        addEditShopVisit={addEditShopVisit}
                                                        onEdit={() => setAddEditShopVisit({ modal: true, mode: 'edit', data: item })}
                                                        onDelete={(e) => {setDeleteShopVisit({ modal: true, data: item });resetBulkToggle()}}
                                                        onView={() => navigate(`/lease/${params?.leaseSlug}/shop-visit/view/${item?.slug}`)}
                                                        viewFile={() => setUploadfileList({ modal: true, mode: 'file', data: item })}
                                                        toggleBulkOps={toggleBulkOps}
                                                    />
                                                )
                                            })}
                                        </TableBody>
                                    </Table>
                                )}
                            </div>
                            <Paper>
                                {!(isLoading?.skeletonLoader || !assetData) && !shopVisitInfo?.list?.length && <NoRecordFound />}
                                <Pagination
                                    pagination={shopVisitInfo?.pagination}
                                    onPageChange={(event, newPage) => getShopVisitList({ ...filter, page: newPage + 1, per_page: shopVisitInfo?.pagination?.per_page, ...(queryConfig?.sort_by && { sort: queryConfig.sort, sort_by: queryConfig.sort_by }) })}
                                    onRowsPerPageChange={(e) => getShopVisitList({ ...filter, page: 1, per_page: e.target.value, ...(queryConfig?.sort_by && { sort: queryConfig.sort, sort_by: queryConfig.sort_by }) })}
                                />
                            </Paper>
                        </Paper>
                    </div>}
            </Paper>
            {
                addEditShopVisit.modal && assetData ?
                    <ShopVisitCRU
                        params={params}
                        fileUpload={handleUpload}
                        addEditShopVisit={addEditShopVisit}
                        modeType={addEditShopVisit.mode}
                        onOpenAttachments={() => setUploadfileList({ modal: true, data: addEditShopVisit?.data, mode: 'view' })}
                        getResponseBack={() => {getShopVisitList(queryConfig); resetBulkToggle();}}
                        onToggleModal={() => setAddEditShopVisit({ modal: false, mode: '', data: null })}
                    /> : null
            }
            {
                uploadfileList.modal ? <ShowAttachments
                    moduleName="Shop Visit"
                    url='lease/delete-attachment'
                    attachmentsData={uploadfileList}
                    getResponseBack={onDeleteAttachments}
                    toggleModalFn={() => setUploadfileList({ modal: false, data: null, mode: '' })}
                    onViewDisabled={addEditShopVisit?.mode === 'view' || uploadfileList?.mode === 'view'}
                    permissionKey='shop_visit'
                /> : null
            }

            {deleteShopVisit.modal || bulk.modal ?
                <DeletePopUp
                    circularloader={isLoading?.buttonLoader}
                    modal={bulk.modal ? bulk.modal : deleteShopVisit.modal}
                    title={bulk.modal ? `Delete Shop Visit (${bulk?.ids?.length})` : 'Delete Shop Visit'}
                    content={bulk.modal ? `Are you sure, you want to Delete ${bulk?.ids?.length > 1 ? 'these' : 'this'} record ?` : `Are you sure, you want to Delete?`}
                    onToggleModal={() => bulk.modal ? resetBulkToggle() : setDeleteShopVisit({ modal: false, data: null })}
                    onDeleteRecords={onDeleteShopvisit}
                /> : null
            }
            {revisionHistory.modal &&
                <RevisionHistory
                    moduleName={"shop_visit"}
                    revisionHistory={revisionHistory}
                    onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
                />
            }
            <FileUploadLayout
                uploadFileStatus={uploadFileStatus}
                open={uploadFileStatus?.modal}
                setUploadFileStatus={setUploadFileStatus}
                uploadFileProgressData={uploadFileProgressData}
                progressRefs={uploadFileProgressData?.progressRefs}
                attachments={uploadFileProgressData?.attachments}
                onDownloadComplete={() => setSlug({})}
            />
            {isLoading?.pageLoader ? <PageLoader /> : null}
        </>

    )
}
export default RoleBaseAccess(ShopVisit, { application: 'lease_revamp', feature: 'shop_visit', operationType: ['R'], leaseNav: true });
